import type { AbilityKind } from '@ic/engine';

// Small line icons (24×24, currentColor) used instead of emoji in the interface.

const PATHS: Record<string, string> = {
  fireBreath: 'M12 3c1 3 4 4.5 4 8.5a4 4 0 0 1-8 0c0-2 1-3 1.5-4 .3 1.5 1 2.2 1.8 2.5C11 8 11 5.5 12 3ZM12 21v-3',
  wingSweep: 'M3 12c4-1 6-4 6-8 2 3 3 6 3 8M21 12c-4-1-6-4-6-8-2 3-3 6-3 8M5 17h14M8 20h8',
  detonate: 'M12 2v4M12 18v4M2 12h4M18 12h4M5 5l2.5 2.5M16.5 16.5 19 19M19 5l-2.5 2.5M7.5 16.5 5 19M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
  timedFuse: 'M12 8v5l3 2M9 2h6M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z',
  kick: 'M4 14h7l3-5 3 2-2 4h4a2 2 0 0 1 2 2v2H4ZM14 4l2 2M18 3l1 3',
  placeMine: 'M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12ZM12 2v4M12 18v4M2 12h4M18 12h4',
  tunnel: 'M3 20V11a9 9 0 0 1 18 0v9M7 20v-8a5 5 0 0 1 10 0v8M3 20h18',
  defuse: 'M14.5 6.5a4 4 0 0 0-5.3 5.3L3 18l3 3 6.2-6.2a4 4 0 0 0 5.3-5.3l-2.6 2.6-2.4-.6-.6-2.4Z',
  dig: 'M4 20 14 10M10 4c4-1 8 2 10 6-3-2-6-2-8-1M7 17l3 3',
  gear: 'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM19 12l2-1-1-3-2 .3-1.3-1.3.3-2-3-1-1 2h-2l-1-2-3 1 .3 2L6 7.3 4 7 3 10l2 1v2l-2 1 1 3 2-.3 1.3 1.3-.3 2 3 1 1-2h2l1 2 3-1-.3-2 1.3-1.3 2 .3 1-3-2-1Z',
  user: 'M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM4 21a8 8 0 0 1 16 0',
  flip: 'M7 4v16M7 20l-3-3M7 20l3-3M17 20V4M17 4l-3 3M17 4l3 3',
  undo: 'M9 14 4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3',
  flag: 'M5 21V4M5 4h11l-2 4 2 4H5',
  restart: 'M20 12a8 8 0 1 1-2.3-5.7M20 4v5h-5',
  check: 'M5 12l5 5 9-10',
  x: 'M6 6l12 12M18 6 6 18',
  cloud: 'M7 18a4 4 0 0 1-.5-8 5.5 5.5 0 0 1 10.6-1.5A4.5 4.5 0 0 1 17 18Z',
  device: 'M7 3h10v18H7ZM11 18h2',
  target: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z',
  hand: 'M8 13V5.5a1.5 1.5 0 0 1 3 0V12M11 11V4.5a1.5 1.5 0 0 1 3 0V12M14 11.5V6a1.5 1.5 0 0 1 3 0v8a7 7 0 0 1-12.5 4.3L3 15.5a1.5 1.5 0 0 1 2.4-1.8L8 16',
  eraser: 'M8 20h12M5 15l9-9 5 5-9 9H8Z',
  hole: 'M12 7c5 0 9 2.2 9 5s-4 5-9 5-9-2.2-9-5 4-5 9-5ZM7 12c1.3 1 3 1.5 5 1.5s3.7-.5 5-1.5',
  wall: 'M3 5h18v14H3ZM3 12h18M9 5v7M15 12v7',
  save: 'M5 3h11l3 3v15H5ZM8 3v5h7V3M8 21v-7h8v7',
  flask: 'M9 3h6M10 3v6l-5 9a2 2 0 0 0 1.8 3h10.4a2 2 0 0 0 1.8-3l-5-9V3M7.5 15h9',
  crown: 'M4 18h16l1-10-5 4-4-6-4 6-5-4Z',
  globe: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9S9.5 5.5 12 3Z',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  cpu: 'M7 7h10v10H7ZM10 10h4v4h-4ZM9 3v4M15 3v4M9 17v4M15 17v4M3 9h4M3 15h4M17 9h4M17 15h4',
  users: 'M9 4a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM2 20a7 7 0 0 1 14 0M16 4.5a3.5 3.5 0 0 1 0 6.5M18 13.5a7 7 0 0 1 4 6.5',
  sun: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z',
  monitor: 'M3 4h18v12H3ZM8 20h8M12 16v4',
  shuffle: 'M3 7h4l10 10h4M3 17h4l3-3M14 10l3-3h4M18 4l3 3-3 3M18 14l3 3-3 3',
  minus: 'M5 12h14',
  plus: 'M12 5v14M5 12h14',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 7v5l3 2',
  arrow: 'M5 12h14M13 6l6 6-6 6',
  tongue: 'M3 12h11a4 4 0 1 0-4-4M3 9v6',
  plantHedge: 'M5 20C5 11 11 5 20 4c-1 9-7 16-15 16ZM5 20l9-9M4 20h16',
  tend: 'M4 10h9v9H4ZM13 12l6-4M6 10a2.5 2.5 0 0 1 5 0M19 11v2M21 9v2M17 13v2',
  first: 'M5 5h2.5v14H5ZM19 6l-9 6 9 6Z',
  prev: 'M16 6l-8 6 8 6Z',
  next: 'M8 6l8 6-8 6Z',
  last: 'M16.5 5H19v14h-2.5ZM5 6l9 6-9 6Z',
  multiply: 'M9 4a5 5 0 1 0 0 10 5 5 0 0 0 0-10ZM17 13v8M13 17h8',
  feast: 'M3 12h18a9 9 0 0 1-18 0ZM8 8c0-2 2-2 2-4M12 8c0-2 2-2 2-4M16 8c0-2 2-2 2-4',
  panToss: 'M4 14a6 6 0 1 0 12 0 6 6 0 0 0-12 0ZM16 14h6M3 6l3 2M7 3l1 3',
  stampede: 'M3 12h10M9 8l4 4-4 4M15 6l5 6-5 6M3 7h3M3 17h3',
  trumpet: 'M3 10v4h3l5 4V6l-5 4ZM15 9a4 4 0 0 1 0 6M18 6a8 8 0 0 1 0 12',
};

export type IconName = keyof typeof PATHS | AbilityKind;

export function Icon({ name, size = 18, className }: { name: IconName; size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24" width={size} height={size} className={`icon ${className ?? ''}`}
      fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
